import React from 'react';
import { Flex, Message } from 'rebass';
import styled from 'styled-components';
import { space } from 'styled-system';

// const BaseMessage = Message.extend`
//   width: 100%
//   z-index: 999
// `;

const Box = styled.div`
  ${space}
`;

const WarningMessage = Message.extend`
  background-color: ${props => props.theme.colors.yellow}
`;

const WarningNotification = ({warning, hideNotification}) => {
  return (
    <WarningMessage>
      <Flex justifyContent='space-between'>
        <Box>ikoni*</Box>
        <Box>{warning}</Box>
        <Box onClick={() => hideNotification()}>X*</Box>
      </Flex>
    </WarningMessage>
  );
};

export default WarningNotification;


// WEBPACK FOOTER //
// ./src/components/notification/WarningNotification.jsx